import { render, staticRenderFns } from "./PromoGif.vue?vue&type=template&id=2853f0fc&"
import script from "./PromoGif.vue?vue&type=script&lang=js&"
export * from "./PromoGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports